import { useEffect, useState } from 'react';
import { formatDistanceFrom } from 'utils/date';

export type DateRelativeToNowOptions = Readonly<{
    /**
     * The date to format.
     */
    date: Date | undefined;
    /**
     * How often to recalculate in milliseconds (defaults to every minute).
     * Disabled when `false`.
     */
    updateMillis?: number | false;
}>;

/**
 * Formats a date relative to supplied date.  Defaults to recalculating every
 * minute if `updateMillis` is not supplied.
 */
export function useDateRelativeToNow({
    date,
    updateMillis = 1000 * 60,
}: DateRelativeToNowOptions) {
    const [description, setDescription] = useState(() =>
        formatDistanceFrom(date, undefined)
    );

    useEffect(() => {
        setDescription(formatDistanceFrom(date, undefined));

        const handle =
            date && typeof updateMillis === 'number' && updateMillis > 0
                ? window.setInterval(() => {
                      setDescription(formatDistanceFrom(date, undefined));
                  }, updateMillis)
                : undefined;

        return () => window.clearInterval(handle);
    }, [date, updateMillis]);

    return description;
}
